import qs from 'qs';
import tools from 'tools';

export default {
  formatHref(url, query) {
    const searchParams = tools.getUrlSearchParams();
    const urlParams = tools.getUrlParams(url);
    const baseUrl = url.split('?')[0] || '';
    const params = qs.stringify({
      ...searchParams,
      ...urlParams,
      ...(query || {}),
    });
    return `${baseUrl}?${params}`;
  },
}


// WEBPACK FOOTER //
// ./src/mods/location.js